export interface AssetListStatusOption {
  value: string;
  label: string;
  color: string;
}

/**
 * Duration options for asset filtering
 */
export const DURATION_OPTIONS: string[] = ['Short', 'Medium', 'Long'];

/**
 * Format options for asset filtering
 */
export const FORMAT_OPTIONS: string[] = ['H 16:9', 'V 9:16', 'V 4:5', 'S 1:1', '16:9', '9:16', '4:5', '1:1'];

/**
 * Allowed formats for format filtering
 */
export const ALLOWED_FORMATS: string[] = ['H 16:9', 'V 9:16', 'V 4:5', 'S 1:1', '16:9', '9:16', '4:5', '1:1'];

/**
 * Categories options for asset filtering
 */
export const CATEGORIES_OPTIONS: string[] = ['VIDEO', 'STILL'];

/**
 * In Use options for asset filtering
 */
export const IN_USE_OPTIONS: string[] = ['YES', 'NO'];

/**
 * Status options with their labels and colors
 */
export const STATUS_OPTIONS: AssetListStatusOption[] = [
  { value: 'TO_DO', label: 'To Do', color: '#69699d' }, // Purple/blue
  { value: 'IN_PROGRESS', label: 'In Progress', color: '#000000' }, // Black
  { value: 'UPCOMING_EXPIRY', label: 'Upcoming Expiry', color: '#f9ad67' }, // Orange
  { value: 'DELAYED', label: 'Delayed', color: '#fd5021' }, // Orange/red
  { value: 'COMPLETED', label: 'Completed', color: '#6dc58f' }, // Green
  { value: 'UNKNOWN', label: 'Unknown', color: '#d9d9d9' }, // Grey
  { value: 'NOT_AFFECTED', label: 'Not Affected', color: '#efefef' }, // Light grey
];

/**
 * Month numbers for release date filtering (01-12)
 */
export const MONTHS: string[] = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];

/**
 * Error message for invalid month
 */
export const UNKNOWN_MONTH_MESSAGE: string = 'Unknown Month';

/**
 * SVG icon paths for dropdown filters
 */
export const SVG_ICON_PATHS: Record<string, string> = {
  SELECTED: 'assets/svg/selected.svg',
  FILTERED: 'assets/svg/filtered.svg',
  UNSELECT: 'assets/svg/unselect.svg',
} as const;

/**
 * Duration matching strings for filtering (lowercase)
 */
export const DURATION_MATCH_STRINGS: Record<string, string> = {
  SHORT: 'short',
  MEDIUM: 'medium',
  LONG: 'long',
} as const;

/**
 * Dropdown filter type constants
 */
export const DROPDOWN_TYPES: Record<string, string> = {
  PROJECT: 'project',
  FOCUS: 'focus',
  TYPE: 'type',
  BETS: 'bets',
  DURATION: 'duration',
  FORMAT: 'format',
  CATEGORIES: 'categories',
  IN_USE: 'inUse',
  STATUS: 'status',
} as const;
